import { get } from 'lodash';

function extraTableParams() {
  return {
    defaultSortField: 'name',
    defaultSortOrder: 'asc',
    isDetailed: false,
    rearrangeCols: false,
    customRowKey: 'uid',
  };
}
const ItemCols = [
  {
    title: '',
    name: 'itemDelete',
    alwaysVisible: true,
    id: 'itemDelete',
    width: '40px',
    sticky: true,
  },
  {
    name: 'field-generic-input',
    width: '400px',
    title: 'Item',
    prop: 'name',
    sticky: true,
    id: 'name',
    searchable: true,
  },
  {
    name: 'field-cat-id',
    width: '152px',
    title: 'Catalog ID',
    id: 'catId',
    prop: 'catId',
    allowAutoComplete: true,
    inputProps: {
      type: 'text',
      disableEdit: true,
    },
  },
  {
    title: 'Deliv.',
    name: 'itemDelivery',
    width: '64px',
    id: 'shipDelivs',
    defaultVisible: true,
    inputProps: {
      icon: 'icon-attacheddeliveriesOL',
    },
  },
  {
    name: 'field-generic-input',
    title: 'Total Item QTY',
    width: '112px',
    prop: 'actualQty',
    id: 'qtyAllDeliveries',
  },
  {
    name: 'qtyNotScheduled',
    title: 'QTY Not In Delivery',
    width: '112px',
    prop: 'masterSummary.notScheduled',
    id: 'qtyNotScheduled',
  },
  {
    name: 'field-generic-input',
    title: 'QTY Unscheduled',
    width: '112px',
    prop: 'qtyUnscheduled',
    id: 'qtyScheduled',
  },{
    name: 'field-generic-input',
    title: 'QTY Scheduled',
    width: '112px',
    prop: 'qtyScheduled',
    id: 'qtyScheduled',
  },
  {
    name: 'field-generic-input',
    title: 'QTY In Transit',
    width: '112px',
    prop: 'qtyInDelivery',
    id: 'qtyInTransit',
  },
  {
    name: 'qtyShortLoad',
    title: 'QTY Short (Load)',
    width: '112px',
    prop: 'qtyShortLoad',
    id: 'underDeliver',
  },
  {
    name: 'qtyShort',
    title: 'QTY Short (Received)',
    width: '112px',
    prop: 'qtyShort',
    id: 'underDeliver',
  },
  {
    name: 'field-generic-input',
    title: 'QTY Received',
    width: '112px',
    prop: 'qtyReceived',
    id: 'qtyReceived',
  },
  // {
  //   name: 'field-generic-input',
  //   title: 'QTY Short (Receive)',
  //   width: '112px',
  //   prop: 'masterSummary',
  //   id: '',
  // },
  {
    name: 'field-ship-items-icon',
    width: '64px',
    title: 'Item Source',
    classRight: 'text-clamp',
    id: 'order',
  },
  {
    name: '',
    title: 'Install Location',
    width: '296px',
    id: 'installLocation',
    formatter(item) {
      if (Array.isArray(item.installLocs)) {
        return item.installLocs.join(', ');
      }
      return '';
    },
  },
  {
    name: 'field-generic-input',
    width: '296px',
    title: 'Level',
    prop: 'itemLevel',
    id: 'level',
  },
  {
    name: 'field-generic-input',
    width: '296px',
    title: 'Zone',
    prop: 'itemZone',
    id: 'zone',
  },
];

export default {
  'item-info': {
    ...extraTableParams(),
    stickeyHeaders: true,
    isCardView: true,
    ...{
      toolBar: {
        hideSearchBar: true,
        bulkActions: () => {
          const opts = [
            {
              name: 'From Production',
              event: 'addItems',
              label: 'From Production',
            },
            {
              name: 'From Inventory',
              event: 'addItems',
              label: 'From Inventory',
            }
          ]
          return opts;
        },
      },
      fields: ItemCols,
    },
  },
};
